export enum InventoryTransferStateEnums {
  //Estados 
  open = 1,
  close = 2,
  annul = 3,
  inTransit = 4
}

export enum InventoryTransferTypeEnums {
  //Tipos
  shop = 1,
  workshop2 = 2,
  workshop3 = 3
}